import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class OrderLexileService extends BaseService {

  constructor(protected override http: HttpClient, protected override router: Router) {
    super(http, router);
    // console.log(22222222222222)
    // this.getInfoPromise = this.get('/user/getInfo');
  }

  async getOrdersList(query: any) {
    // const searchParams = new URLSearchParams();
    // Object.keys(query).forEach(key => searchParams.append(key, query[key]));
    return super.get(`/v3/api/orders-lexile/orders/list`, query);
  }

  async getOrdersConsumeList(query: any) {
    // const searchParams = new URLSearchParams();
    // Object.keys(query).forEach(key => searchParams.append(key, query[key]));
    return super.get(`/v3/api/orders-lexile/orders/consume`, query);
  }

}
